module.exports = __webpack_public_path__ + "img/1_012.e0689858.jpg";